
import { defineComponent, computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { helper as $h } from '@/utils/helper'
import TopBar from '@/components/top-bar/Main.vue'
import MobileMenu from '@/components/mobile-menu/Main.vue'
// import DarkModeSwitcher from "@/components/dark-mode-switcher/Main.vue";
import SideMenuTooltip from '@/components/side-menu-tooltip/Main.vue'
import { linkTo, enter, leave } from './index'
import context from '@cloudfun/core'

export default defineComponent({
  components: {
    TopBar,
    MobileMenu,
    // DarkModeSwitcher,
    SideMenuTooltip
  },
  setup () {
    const application = context.current
    const policy = application?.policy
    const route = useRoute()
    const router = useRouter()
    const formattedMenu = ref([])
    const sideMenu = computed(() => policy?.makeMenu() || [])

    watch(
      computed(() => route.fullPath),
      () => {
        formattedMenu.value = $h.toRaw(sideMenu.value)
      }
    )

    const adminTitle = computed(() => application?.model.state.configuration.value.AdminTitle || "貓公寓管理後臺")

    const store = useStore()
    let _pollTimer: ReturnType<typeof setInterval> | null = null

    onMounted(() => {
      cash('body')
        .removeClass('error-page')
        .removeClass('login')
        .addClass('app')
      formattedMenu.value = $h.toRaw(sideMenu.value)
      store.dispatch('customerContact/fetchUnreadCount').catch(() => { /* 忽略查詢失敗 */ })
      _pollTimer = setInterval(() => {
        store.dispatch('customerContact/fetchUnreadCount').catch(() => { /* 忽略查詢失敗 */ })
      }, 60000)
    })

    onUnmounted(() => {
      if (_pollTimer) clearInterval(_pollTimer)
    })

    const contactUnread = computed(() => store.getters['customerContact/unreadCount'] as number)

    return {
      formattedMenu,
      router,
      linkTo,
      enter,
      leave,
      adminTitle,
      contactUnread
    }
  }
})
